import { isInsightAccountPath, isInsightWebEnabled } from '@/utils/insightWebEnabled'

export default defineNuxtRouteMiddleware((to) => {
  // 1. 非洞察账号页直接放行
  if (!isInsightAccountPath(to.path)) {
    return
  }
  // 修改说明：门控改用请求/浏览器访问域名 修改功能开始 #20261103175800 2026-11-03 17:58:00
  // 2. SSR 取 Host，客户端取 hostname
  let host = ''
  if (process.server) {
    const headers = useRequestHeaders(['host'])
    host = (headers && headers.host) || ''
  } else if (typeof window !== 'undefined') {
    host = window.location.hostname || ''
  }
  // 3. 非白名单访问域名则踢回我的资源
  if (!isInsightWebEnabled(host)) {
    return navigateTo('/account/course')
  }
  // 修改功能结束 #20261103175800
})
